export const validateCpf = (cpf: string): boolean => {
  if (typeof cpf !== 'string') return false;
  cpf = cpf.replace(/[\s.-]*/gim, '');
  if (
    !cpf ||
    cpf.length != 11 ||
    cpf == '00000000000' ||
    cpf == '11111111111' ||
    cpf == '22222222222' ||
    cpf == '33333333333' ||
    cpf == '44444444444' ||
    cpf == '55555555555' ||
    cpf == '66666666666' ||
    cpf == '77777777777' ||
    cpf == '88888888888' ||
    cpf == '99999999999'
  ) {
    return false;
  }
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto == 10 || resto == 11) resto = 0;
  if (resto != parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto == 10 || resto == 11) resto = 0;
  if (resto != parseInt(cpf.substring(10, 11))) return false;
  return true;
};

export const validatePassport = (passport: string): boolean => {
  if (passport.length >= 8) {
    return true;
  }
  return false;
};

export const onlyLettersAndNumbers = (phrase: string) => {
  const removedSpecialCharacters = phrase.replace(/[&/\\#,+()$~%.'":*?<>={}[\]@!-]/g, '');
  return removedSpecialCharacters;
};

export const onlyLetters = (phrase: string) => {
  const removedNumbers = phrase.replace(/[\d]/g, '');
  const removedSpecialCharacters = removedNumbers.replace(/[&/\\#,+()$~%.'":*?<>{}[\]@!]/g, '');
  return removedSpecialCharacters;
};

export const onlyNumbers = (phrase: string) => {
  const removedNumbers = phrase.replace(/\D/g, '');
  const removedSpecialCharacters = removedNumbers.replace(/[&/\\#,+()$~%.'":*?<>{}[\]@!]/g, '');

  return removedSpecialCharacters;
};

export function validateEmail(email: string) {
  const re =
    // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email.trim()).toLowerCase());
}

export function validateDate(date: string): string | null {
  const dateWithout1Char = date.split('/');
  const dateFormat = `${dateWithout1Char[2]}-${dateWithout1Char[1]}-${dateWithout1Char[0]}`;
  const dateDate = new Date(dateFormat + 'T00:00:00');
  if (dateDate.getTime() && dateDate >= new Date(1900, 0, 1) && dateDate <= new Date(Date.now())) return dateFormat;
  return null;
}

export function validateName(name: string) {
  const nameSplitted = name.trim().split(' ');
  if (nameSplitted.length >= 2) {
    const firstName = nameSplitted[0];
    const lastName = nameSplitted[nameSplitted.length - 1];
    if (firstName.length >= 2 && lastName.length >= 2) return true;
  }

  return false;
}

export function validateCep(cep: string) {
  const regex = /^[0-9]{5}-[0-9]{3}$/;
  if (cep.length > 0) {
    return regex.test(cep);
  }
  return false;
}

export function validateNumero(cep: string) {
  const regex = /^[0-9]+$/;
  if (cep.length > 0) {
    return regex.test(cep);
  }
  return false;
}

export function calculateAge(dateString: string): number {
  const birthday = new Date(dateString);
  const ageDifMs = Date.now() - birthday.getTime();
  const ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function isOlderThan(date: string, comparisonAge: number) {
  const checkAge = calculateAge(date);
  return checkAge >= comparisonAge;
}

export function isYoungerThan(date: string, comparisonAge: number) {
  const checkAge = calculateAge(date);
  return checkAge <= comparisonAge;
}
